import { AssetLoader } from "./AssetLoader";
import { Renderer } from "./Renderer";

export class Background {
  static HEIGHT = 600;
  static WIDTH = 1000;
  heightMap: number[];
  renderer: Renderer;

  constructor() {
    this.renderer = new Renderer(Background.WIDTH, Background.HEIGHT);
    this.heightMap = Array.from({ length: Background.WIDTH });
  }

  refresh(startX: number, endX: number) {
    const ctx = this.renderer.ctx;
    ctx.fillStyle = "#000000";
    ctx.fillRect(startX, 0, endX - startX, Background.HEIGHT);

    for (let x = startX; x <= endX; x++) {
      ctx.fillStyle = "#00FF00";
      ctx.fillRect(
        x,
        this.heightMap[x],
        1,
        Background.HEIGHT - this.heightMap[x]
      );
    }
  }

  render(r: Renderer) {
    r.ctx.drawImage(this.renderer.canvas, 0, 0);
  }

  query(x: number, y: number) {
    return y >= this.heightMap[Math.round(x)];
  }

  async snapshot() {
    return {
      renderer: await this.renderer.snapshot(),
    };
  }

  async restore(snapshot: any) {
    await this.renderer.restore(snapshot.renderer);
  }

  static async fromSnapshot(snapshot: ReturnType<Background["snapshot"]>) {
    const newBackground = new Background();
    await newBackground.restore(snapshot);
    return newBackground;
  }
}
